import React from 'react'
import { SettingsMenuButtonWithIcon } from 'src/editor/shared/components/settings-menu-buttons/settings-menu-button-with-icon'
import {
  ActionIdType,
  ActionSaveType,
} from 'src/editor/shared/types/automation-rules/actions-types'
import { automationRuleActionsTitlesLocaleKeys } from './constants/loco-keys'
import { getActionIcon } from './utils/get-action-icon'
import { getAutomationRuleActionIdAndLabel } from './utils/get-automation-rule-action-id-and-label'

interface FullAddedActionsListProps {
  actions: ActionSaveType[]
  onOpenEditAction: (id: ActionIdType) => void
}

export const FullAddedActionsList = ({
  actions,
  onOpenEditAction,
}: FullAddedActionsListProps) => {
  return (
    <div className="flex flex-col gap-4">
      {actions.map(action => {
        const { id, label } = getAutomationRuleActionIdAndLabel(action) || {}
        return (
          <SettingsMenuButtonWithIcon
            key={id}
            title={automationRuleActionsTitlesLocaleKeys[action.type]}
            subtitle={label}
            iconBefore={() => getActionIcon(action.type)}
            onClick={() => {
              onOpenEditAction(action.id)
            }}
          />
        )
      })}
    </div>
  )
}
